import React, { PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';
import { translate } from 'react-i18next';

import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import I18nLink from 'widgets/I18nLink';
import { loadSitemap } from 'actions';
import { sitemapSelector, hasSitemapSelector } from 'selectors';
import { createDefaultPromise } from 'utils';

class SitemapPage extends PureComponent {
  render() {
    const { sitemap, t } = this.props;

    return (
      <Grid className="sitemap">
        {Object.keys(sitemap).map(key => (
          <Row key={key} className="sitemap-country">
            <Col lg={12}>
              <h2>{t(key, { ns: 'countries' })}</h2>

              {sitemap[key].map(url => (
                <div key={url.url}>
                  <I18nLink to={`/${url.url}/`}>
                    {t(url.titleEn, { ns: 'sitemap' }) || url.url}
                  </I18nLink>
                </div>
              ))}
            </Col>
          </Row>
        ))}
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    sitemap: sitemapSelector(state)
  };
}

export default asyncConnect(
  [{
    promise: createDefaultPromise(hasSitemapSelector, loadSitemap)
  }],
  mapStateToProps,
  { loadSitemap }
)(
    translate(['translation'])(SitemapPage)
);




// WEBPACK FOOTER //
// ./src/components/SitemapPage/index.js